import { useTracking } from '@edreamsodigeo/frontend-core';
import { useModificationTripInfo } from "../../providers/Modification";
import { useTrackingPage } from "./";
export const useTrackModificationPage = () => {
  const {
    trackPage
  } = useTracking();
  const {
    bookingId,
    isPrime
  } = useModificationTripInfo();
  const {
    trackPageV2
  } = useTrackingPage({
    bookingId,
    isPrime
  });
  const trackPageLaunch = (label, options = {}) => {
    trackPage(label, {
      ...{
        funnel: false,
        customDimensions: {
          dimension69: bookingId,
          dimension31: isPrime ? 'subscriber' : 'non-subscriber'
        }
      },
      ...options
    });
  };
  return {
    trackPage: trackPageLaunch,
    trackPageV2
  };
};